<template>
  <section>
    <ContentSectionLoader v-show="!loaded" />
    <Transition name="fade">
      <div class="tabs">
        <ul class="tabs__tab md:inline-flex">
          <li
            :class="{ 'current': activeTab === 'selectColumns', 'disabled': activeTab !== 'selectColumns' }"
            class="w-full md:w-auto"
          >
            <a
              id="tab-selectColumns"
              :aria-selected="activeTab === 'selectColumns'"
              href="#"
              v-text="'1. Select Columns'"
            />
          </li>
          <li
            :class="{ 'current': activeTab === 'addFilters', 'disabled': activeTab !== 'addFilters' }"
            class="w-full md:w-auto"
          >
            <a
              id="tab-addFilters"
              :aria-selected="activeTab === 'addFilters'"
              href="#"
              v-text="'2. Add Filters'"
            />
          </li>
          <li
            :class="{ 'current': activeTab === 'runReport', 'disabled': activeTab !== 'runReport' }"
            class="w-full md:w-auto"
          >
            <a
              id="tab-runReport"
              :aria-selected="activeTab === 'runReport'"
              href="#"
              v-text="'3. Run/Save Report'"
            />
          </li>
        </ul>
        <div class="tabs__tab_content">
          <div
            v-show="activeTab === 'selectColumns'"
            :aria-hidden="activeTab === 'selectColumns'"
            aria-labelledby="tab-selectColumns"
          >
            <SelectColumns
              :pre-selected="selectedColumns"
              @columnsSelected="updateSelectedColumns"
              @tabNavigation="handleTabNavigation"
            />
          </div>
          <div
            v-show="activeTab === 'addFilters'"
            :aria-hidden="activeTab === 'addFilters'"
            aria-labelledby="tab-addFilters"
          >
            <AddFilters
              :pre-selected="activeFilters"
              @tabNavigation="handleTabNavigation"
              @filterAdded="updateActiveFilters"
              @filterRemoved="updateActiveFilters"
            />
          </div>
          <div
            v-show="activeTab === 'runReport'"
            :aria-hidden="activeTab === 'runReport'"
            aria-labelledby="tab-runReport"
          >
            <RunReport
              :active-filters="activeFilters"
              :report="report"
              :selected-columns="selectedColumns"
              @tabNavigation="handleTabNavigation"
            />
          </div>
        </div>
      </div>
    </Transition>
  </section>
</template>

<script type="text/babel">
import { mapActions, mapGetters } from 'vuex'
import SelectColumns from './reports/SelectColumns'
import AddFilters from './reports/AddFilters'
import RunReport from './reports/RunReport'

export default {
  name: 'MembershipReportForm',
  components: {
    SelectColumns,
    AddFilters,
    RunReport,
  },
  props: {
    reportUuid: {
      type: String,
      required: false,
      default: '',
    },
  },
  data() {
    return {
      selectedColumns: [],
      activeFilters: [],
      activeTab: 'selectColumns',
      tabOrder: [
        'selectColumns',
        'addFilters',
        'runReport',
      ],
      loaded: false,
    }
  },
  computed: {
    ...mapGetters({
      report: 'membershipGetMembershipReport',
    }),
  },
  watch: {
    report(element) {
      this.selectedColumns = element.attributes.configuration.columns
      this.activeFilters = element.attributes.configuration.filters
    },
  },
  async mounted() {
    await this.$nextTick()

    if (this.reportUuid) {
      this.getMembershipReport(this.reportUuid).then(() => {
        this.loaded = true
      })
    } else {
      this.loaded = true
    }
  },
  methods: {
    ...mapActions({
      getMembershipReport: 'membershipGetMembershipReport',
    }),
    updateSelectedColumns(payload) {
      this.selectedColumns = payload
    },
    updateActiveFilters(payload) {
      this.activeFilters = payload
    },
    handleTabNavigation(payload) {
      if (this.activeTab === payload.current) {
        if (payload.direction === 'back') {
          this.activeTab = this.tabOrder[this.tabOrder.indexOf(this.activeTab) - 1]
        } else if (payload.direction === 'next') {
          this.activeTab = this.tabOrder[this.tabOrder.indexOf(this.activeTab) + 1]
        }
      }
    },
  },
}
</script>
